import React, { Component } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Icon, Grid, Label } from 'semantic-ui-react';
import util from 'utils/utils';

import { UserChip } from 'components/lib/Chips';

const Bar = styled.div`
  height: 60px;
  padding: 15px 20px;
  vertical-align: middle;
  background-image: linear-gradient(to bottom right, ${({ theme }) => theme.secondaryColour}, ${({ theme }) => util.adjustColour(theme.secondaryColour, 0.5)});
  top: 50px;
  width: 100%;
  z-index: 8;
  position: fixed;
`;

class UserStatusBar extends Component {
  render() {
    const { profileUser } = this.props;
    if (!profileUser || !profileUser.profile) return null;
    return (
      <Bar>
        <Grid>
          <Grid.Column computer={10} tablet={10} mobile={16} verticalAlign="middle">
            <UserChip user={profileUser} inverted />
            {util.isInRole(profileUser, 'org.viewDashboard', profileUser.organisation)
              && (
              <Label style={{ marginLeft: 10 }} size="small" color="teal">
                <Icon name="rocket" />
                {' '}
                Admin
              </Label>
              )
            }
          </Grid.Column>
          <Grid.Column computer={6} tablet={9} mobile={12} textAlign="right" />
        </Grid>
      </Bar>
    );
  }
}

const UserStatusBarContainer = withRouter(connect(
  null,
)(UserStatusBar));

export default withTranslation()(UserStatusBarContainer);
